var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    className: "injected-svg",
    "data-src": "/static/media/pencil.ffd1afc4.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81792 13.7238L14.4422 4.25863C15.1879 3.51295 15.1879 2.29997 14.4422 1.55926C13.6965 0.81358 12.4835 0.81358 11.7428 1.55926L2.27266 11.1786L1.03797 14.8826C1.02234 14.9295 1.06696 14.9741 1.11387 14.9585L4.81792 13.7238Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.4f7542af9080de8cdeab9334440734fd.svg";
export { ForwardRef as ReactComponent };